import useForceUpdate from './useForceUpdate';
import {useMemo} from 'react';
import abstractGetSyncPromise, {
    GetSyncPromise,
    GetSyncPromiseOptions
} from '../abstractGetSyncPromise';
import {debounce} from 'lodash';

export {SyncPromise, GetSyncPromise} from '../abstractGetSyncPromise';

export default function useGetSyncPromise<T>(options?: GetSyncPromiseOptions): GetSyncPromise {
    const forceUpdate = useForceUpdate();
    return useMemo(() => {
        const debouncedForceUpdate = debounce(forceUpdate);
        return abstractGetSyncPromise({
            onPromiseReject: debouncedForceUpdate,
            onPromiseResolve: debouncedForceUpdate,
            ...options
        });
    }, [forceUpdate, options]);
}
